
import { useState, useEffect } from 'react';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import IntroductionSection from './components/IntroductionSection';
import ExampleSection from './components/ExampleSection';
import CalculatorSection from './components/CalculatorSection';
import FeaturesSection from './components/FeaturesSection';
import FAQSection from './components/FAQSection';
import GetStartedSection from './components/GetStartedSection';
import Footer from './components/Footer';
import AboutSection from './components/AboutSection';

export default function HomePage() {
  const [btcPrice, setBtcPrice] = useState('$117,000');

  useEffect(() => {
    // Simulate BTC price updates
    const interval = setInterval(() => {
      const price = Math.floor(Math.random() * 10000) + 110000;
      setBtcPrice(`$${(price / 1000).toFixed(0)},000`);
    }, 30000);
    
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="min-h-screen bg-[#f8f8f0]">
      <Header btcPrice={btcPrice} />
      <HeroSection />
      <IntroductionSection />
      <FeaturesSection />
      <ExampleSection />
      <CalculatorSection />
      <FAQSection />
      <AboutSection />
      <GetStartedSection />
      <Footer />
    </div>
  );
}
